var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bottomBox"},[_c('p',[_vm._v("  Copyright © 河南省豫资大数据研究院有限公司版权所有 All Rights Reserved. 版权所有，未经书面授权禁止使用 ")]),_c('p',[_vm._v(" ICP备案/许可证号： "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","data-v-838e4485":""}},[_vm._v("豫ICP备2025115454号")])])])])
}]

export { render, staticRenderFns }